(function () {
  'use strict';

  // Get currency info from page
  const currencyCodeEl = document.getElementById('currencyCode');
  const currencySymbolEl = document.getElementById('currencySymbol');
  const currencyCode = currencyCodeEl ? currencyCodeEl.value : 'USD';
  const currencySymbol = currencySymbolEl ? currencySymbolEl.value : '$';
  const rtlLocales = ['EUR', 'DKK'];

  // Order summary state
  const orderSummaryState = {
    mainProduct: null,
    upsells: [],
    subscriptionUpsell: null, // Subscription upsell widget product
    subscriptionInfo: {},
  };

  // DOM elements
  const orderSummaryEl = document.getElementById('bx-system-order-summary');
  if (!orderSummaryEl) return;

  const itemCountEl = document.getElementById('order-summary-item-count');
  const toggleBtn = document.getElementById('order-summary-toggle');
  const toggleTextEl = document.getElementById('order-summary-toggle-text');
  const toggleIconPlus = toggleBtn?.querySelector('.toggle-icon-plus');
  const toggleIconMinus = toggleBtn?.querySelector('.toggle-icon-minus');
  const detailsEl = document.getElementById('order-summary-details');
  const itemsListEl = document.getElementById('order-summary-items');

  // Helper: Format price
  function formatPrice(price) {
    const rightToLeft = rtlLocales.includes(currencyCode);
    // Remove trailing zeroes by converting to number and back to string
    const formattedPrice = parseFloat((price / 100).toFixed(2)).toString();
    return rightToLeft
      ? `${formattedPrice} ${currencySymbol}`
      : `${currencySymbol}${formattedPrice}`;
  }

  // Helper: Get rendered price (from filtrationSystem.js pattern)
  function getRenderedPrice(price) {
    return (price / 100).toFixed(2);
  }

  // Helper: Get product title from variant
  function getProductTitle(variant) {
    if (!variant) return '';
    // Try to get title from variant title or product title
    const variantTitle = variant.title || '';
    const productTitle = variant.product?.title || '';
    return variantTitle || productTitle;
  }

  // Helper: Get upsell title
  function getUpsellTitle(upsellId) {
    const upsellContainer = document.getElementById(
      upsellId + '-upsell-container'
    );
    if (!upsellContainer) return '';
    const titleEl = upsellContainer.querySelector('.upsell-info-title strong');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  // Helper: Get subscription info for an item
  function getSubscriptionInfo(itemId, isUpsell = false) {
    // Check if there's subscription info stored
    if (orderSummaryState.subscriptionInfo[itemId]) {
      return orderSummaryState.subscriptionInfo[itemId];
    }

    // Try to find subscription widget info
    // IMPORTANT: Only return subscription info for the subscription upsell widget item
    // Other upsells (like priming pump, water spigot, etc.) don't have subscriptions
    if (isUpsell && itemId === 'subscription-upsell') {
      // For subscription upsell widget only, check if there's a subscription widget
      const subscriptionWidget = document.querySelector(
        '.subscription-upsell-widget'
      );
      if (subscriptionWidget) {
        const subscriptionRadio = subscriptionWidget.querySelector(
          'input[type="radio"][value="subscription"]:checked'
        );
        if (subscriptionRadio) {
          // Try to get from active frequency button first (most reliable)
          const activeFrequencyBtn = subscriptionWidget.querySelector(
            '.subscription-upsell-widget__frequency-button.active'
          );
          if (activeFrequencyBtn) {
            const planName =
              activeFrequencyBtn.dataset.sellingPlanName ||
              activeFrequencyBtn.textContent.trim();

            // Extract frequency from plan name
            // Plan names can be like "subscription every 12 months" or "every 12 months"
            let frequency = null;

            // Try pattern: "every X months/weeks"
            const frequencyMatch = planName.match(
              /every\s+(\d+)\s+(month|months|week|weeks)/i
            );
            if (frequencyMatch) {
              frequency = `every ${frequencyMatch[1]} ${frequencyMatch[2]}`;
            } else {
              // Try pattern: "X months" or "X month"
              const simpleMatch = planName.match(
                /(\d+)\s+(month|months|week|weeks)/i
              );
              if (simpleMatch) {
                frequency = `every ${simpleMatch[1]} ${simpleMatch[2]}`;
              }
            }

            if (frequency) {
              return {
                frequency: frequency,
                planName: planName.replace(/^subscription\s+/i, '').trim(),
              };
            }
          }

          // Fallback: Try to get from selling plan select
          const sellingPlanSelect = subscriptionWidget.querySelector(
            'select[id*="selling_plan"]'
          );
          if (sellingPlanSelect && sellingPlanSelect.value) {
            const selectedOption =
              sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
            const planName = selectedOption.textContent.trim();
            // Extract frequency from plan name
            const frequencyMatch = planName.match(
              /every\s+(\d+)\s+(month|months|week|weeks)/i
            );
            if (frequencyMatch) {
              return {
                frequency: `every ${frequencyMatch[1]} ${frequencyMatch[2]}`,
                planName: planName.replace(/^subscription\s+/i, '').trim(),
              };
            } else {
              // Try simple pattern
              const simpleMatch = planName.match(
                /(\d+)\s+(month|months|week|weeks)/i
              );
              if (simpleMatch) {
                return {
                  frequency: `every ${simpleMatch[1]} ${simpleMatch[2]}`,
                  planName: planName.replace(/^subscription\s+/i, '').trim(),
                };
              }
            }
          }
        }
      }
    }

    return null;
  }

  // Update item count
  function updateItemCount() {
    const totalItems = orderSummaryState.mainProduct ? 1 : 0;
    const totalUpsells = orderSummaryState.upsells.length;
    const subscriptionUpsellCount = orderSummaryState.subscriptionUpsell
      ? 1
      : 0;
    const total = totalItems + totalUpsells + subscriptionUpsellCount;

    if (itemCountEl) {
      itemCountEl.textContent = `${total} ${total === 1 ? 'Item' : 'Items'}`;
    }
  }

  // Render order summary items
  function renderOrderSummaryItems() {
    if (!itemsListEl) return;

    itemsListEl.innerHTML = '';

    // Main product (no price shown)
    if (orderSummaryState.mainProduct) {
      const item = createOrderSummaryItem(
        orderSummaryState.mainProduct.title,
        0, // Main product shows no price
        0, // No compare price
        null, // No subscription info for main product
        1,
        true // isMainProduct flag
      );
      itemsListEl.appendChild(item);
    }

    // Subscription upsell widget product (Fluoride Filters)
    if (orderSummaryState.subscriptionUpsell) {
      // Always get fresh subscription info from DOM to ensure it's up to date
      let subscriptionInfo = null;
      const subscriptionWidget = document.querySelector(
        '.subscription-upsell-widget'
      );
      const isSubscription = subscriptionWidget
        ? !!subscriptionWidget.querySelector(
            'input[type="radio"][value="subscription"]:checked'
          )
        : orderSummaryState.subscriptionUpsell.isSubscription;

      if (isSubscription) {
        subscriptionInfo = getSubscriptionInfo('subscription-upsell', true);
        if (subscriptionInfo) {
          orderSummaryState.subscriptionInfo['subscription-upsell'] =
            subscriptionInfo;
        } else {
          // Fallback to stored info
          subscriptionInfo =
            orderSummaryState.subscriptionUpsell.subscriptionInfo;
        }
      }
      // Title already includes quantity (e.g., "2 Fluoride Filters"), so pass quantity as 1
      // to avoid duplicating it in the display
      // Pass isSubscriptionUpsell flag to identify this item
      const item = createOrderSummaryItem(
        orderSummaryState.subscriptionUpsell.title,
        orderSummaryState.subscriptionUpsell.price,
        orderSummaryState.subscriptionUpsell.compareAtPrice,
        subscriptionInfo,
        1, // Don't add quantity prefix since title already has it
        false, // isMainProduct = false
        true, // isSubscriptionUpsell = true
        isSubscription // isSubscription
      );
      itemsListEl.appendChild(item);
    }

    // Regular upsells
    orderSummaryState.upsells.forEach(upsell => {
      // Regular upsells (priming pump, water spigot, etc.) don't have subscriptions
      // Only the subscription upsell widget item has subscription info
      // So we don't pass subscription info for regular upsells
      const item = createOrderSummaryItem(
        upsell.title,
        upsell.price,
        upsell.compareAtPrice,
        null, // No subscription info for regular upsells
        upsell.quantity || 1
      );
      itemsListEl.appendChild(item);
    });
  }

  // Create order summary item element
  function createOrderSummaryItem(
    title,
    price,
    comparePrice,
    subscriptionInfo,
    quantity = 1,
    isMainProduct = false,
    isSubscriptionUpsell = false,
    isSubscription = false
  ) {
    const li = document.createElement('li');
    li.className = 'bx-system-included-order-summary__item';

    const hasDiscount = comparePrice && comparePrice > price;
    const displayPrice = price || 0;
    const displayComparePrice = hasDiscount ? comparePrice : null;

    // Item title with quantity
    let titleText = quantity > 1 ? `${quantity} ${title}` : title;

    // Add "(Included)" if price is 0 and not main product
    if (displayPrice === 0 && !isMainProduct) {
      titleText += ' (Included)';
    }

    const titleEl = document.createElement('div');
    titleEl.className = 'bx-system-included-order-summary__item-title';
    titleEl.textContent = titleText;
    li.appendChild(titleEl);

    // Price container (show for all items except main product)
    // Show price even if it's 0 (for included items like priming pump)
    if (!isMainProduct) {
      const priceContainer = document.createElement('div');
      priceContainer.className = 'bx-system-included-order-summary__item-price';

      if (displayComparePrice && displayComparePrice > 0) {
        const comparePriceEl = document.createElement('span');
        comparePriceEl.className =
          'bx-system-included-order-summary__item-compare-price';
        comparePriceEl.textContent = formatPrice(displayComparePrice);
        priceContainer.appendChild(comparePriceEl);
      }

      const currentPriceEl = document.createElement('span');
      currentPriceEl.className =
        'bx-system-included-order-summary__item-current-price';
      currentPriceEl.textContent = formatPrice(displayPrice);
      priceContainer.appendChild(currentPriceEl);

      li.appendChild(priceContainer);
    }

    // Purchase type label (one-time or subscription)
    // For subscription upsell widget items, always show label (one-time or subscription)
    // For other items, show label only if they have subscription info
    if (isSubscriptionUpsell) {
      // For subscription upsell widget, show label based on isSubscription parameter
      const purchaseTypeBox = document.createElement('div');
      purchaseTypeBox.className =
        'bx-system-included-order-summary__item-subscription';

      if (isSubscription && subscriptionInfo && subscriptionInfo.frequency) {
        // Show subscription details with frequency
        const subscriptionPrice =
          displayPrice > 0 ? formatPrice(displayPrice) : 'free';
        // Format title text for subscription
        let subscriptionTitleText = titleText;
        const numberMatch = titleText.match(/^(\d+)\s+(.+)/);
        if (numberMatch) {
          subscriptionTitleText = `a Set of ${numberMatch[1]} ${numberMatch[2]}`;
        } else if (!titleText.includes('Set of')) {
          subscriptionTitleText = `a ${titleText}`;
        }
        purchaseTypeBox.innerHTML = `
          <p>
            Recurring subscription: <strong>${subscriptionPrice} ${subscriptionInfo.frequency}</strong> for ${subscriptionTitleText}, billed automatically.
          </p>
        `;
      } else {
        // Show one-time purchase label
        purchaseTypeBox.innerHTML = `
          <p>
            One-time purchase
          </p>
        `;
      }
      li.appendChild(purchaseTypeBox);
    } else if (subscriptionInfo) {
      // For other items with subscription info
      const subscriptionBox = document.createElement('div');
      subscriptionBox.className =
        'bx-system-included-order-summary__item-subscription';
      const subscriptionPrice =
        displayPrice > 0 ? formatPrice(displayPrice) : 'free';
      // Format title text for subscription
      let subscriptionTitleText = titleText;
      const numberMatch = titleText.match(/^(\d+)\s+(.+)/);
      if (numberMatch) {
        subscriptionTitleText = `a Set of ${numberMatch[1]} ${numberMatch[2]}`;
      } else if (!titleText.includes('Set of')) {
        subscriptionTitleText = `a ${titleText}`;
      }
      subscriptionBox.innerHTML = `
        <p>
          Recurring subscription: <strong>${subscriptionPrice} ${subscriptionInfo.frequency}</strong> for ${subscriptionTitleText}, billed automatically.
        </p>
      `;
      li.appendChild(subscriptionBox);
    }

    return li;
  }

  // Update main product from variant change
  function updateMainProduct(variant) {
    if (!variant) {
      orderSummaryState.mainProduct = null;
      updateOrderSummary();
      return;
    }

    const selectedVariantCostEl = document.getElementById(
      'selectedVariantCost'
    );
    const selectedVariantComparePriceEl = document.getElementById(
      'selectedVariantComparePrice'
    );

    const price = selectedVariantCostEl
      ? parseInt(selectedVariantCostEl.value)
      : variant.price || 0;
    const comparePrice = selectedVariantComparePriceEl
      ? parseInt(selectedVariantComparePriceEl.value) || 0
      : variant.compare_at_price || 0;

    // Get product title - try multiple sources
    let title = '';

    // Try variant title first (e.g., "Legacy System (3 gal)")
    if (variant.title) {
      title = variant.title;
    }

    // If no title or title looks like a variant option string, try product title
    if (!title || title.includes(' / ')) {
      // Try to get from product title in the page
      const productTitleEl = document.querySelector(
        '.product-title, h1.product-title, [data-product-title]'
      );
      if (productTitleEl) {
        title = productTitleEl.textContent.trim();
      } else if (variant.product && variant.product.title) {
        title = variant.product.title;
      }

      // If we have a variant title with options, try to format it nicely
      if (variant.title && variant.title.includes(' / ')) {
        // Format like "Legacy System (3 gal)" from variant options
        const parts = variant.title.split(' / ');
        if (parts.length >= 2) {
          // Use the first part (color) and try to extract system info
          const colorPart = parts[0];
          const filterPart = parts[1];
          // Try to create a readable title
          if (title) {
            title = `${title} (${filterPart})`;
          } else {
            title = `${colorPart} System (${filterPart})`;
          }
        }
      }
    }

    // If still no title, use a default
    if (!title) {
      title = 'System';
    }

    orderSummaryState.mainProduct = {
      id: variant.id,
      title: title,
      price: price,
      compareAtPrice: comparePrice,
      variant: variant,
    };

    updateOrderSummary();
  }

  // Update subscription upsell widget product
  function updateSubscriptionUpsell(eventDetail) {
    if (!eventDetail || !eventDetail.upsellEnabled) {
      orderSummaryState.subscriptionUpsell = null;
      updateOrderSummary();
      return;
    }

    // Get the subscription widget element
    const subscriptionWidget = document.querySelector(
      '.subscription-upsell-widget'
    );
    if (!subscriptionWidget) {
      orderSummaryState.subscriptionUpsell = null;
      updateOrderSummary();
      return;
    }

    // Check if the widget is selected (has 'selected' class on main product)
    const mainProductEl = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__main-product'
    );
    if (!mainProductEl || !mainProductEl.classList.contains('selected')) {
      orderSummaryState.subscriptionUpsell = null;
      updateOrderSummary();
      return;
    }

    // Get product title from description list
    const descriptionList = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__main-product-content ul'
    );
    let title = 'Fluoride Filters';
    if (descriptionList) {
      const firstListItem = descriptionList.querySelector('li:first-child');
      if (firstListItem) {
        // Extract title from "Set of 2 Fluoride Filters" -> "2 Fluoride Filters"
        const listText = firstListItem.textContent.trim();
        const match = listText.match(/Set of (\d+) (.+)/);
        if (match) {
          title = `${match[1]} ${match[2]}`;
        } else {
          title = listText.replace('Set of ', '');
        }
      }
    }

    // Get subscription info if it's a subscription
    let subscriptionInfo = null;
    const isSubscription = eventDetail.isSubscription || false;
    if (isSubscription) {
      subscriptionInfo = getSubscriptionInfo('subscription-upsell', true);
      if (subscriptionInfo) {
        orderSummaryState.subscriptionInfo['subscription-upsell'] =
          subscriptionInfo;
      }
    }

    // Get prices from event detail
    const price = eventDetail.upsellPrice || eventDetail.originalPrice || 0;
    const comparePrice = eventDetail.compareAtPrice || 0;
    // Get quantity from event detail (cart quantity)
    const quantity = eventDetail.quantity || 1;

    orderSummaryState.subscriptionUpsell = {
      id: 'subscription-upsell',
      title: title,
      price: price,
      compareAtPrice: comparePrice,
      quantity: quantity,
      isSubscription: isSubscription,
      subscriptionInfo: subscriptionInfo,
    };

    updateOrderSummary();
  }

  // Update subscription upsell from DOM (fallback method)
  function updateSubscriptionUpsellFromDOM() {
    const subscriptionWidget = document.querySelector(
      '.subscription-upsell-widget'
    );
    if (!subscriptionWidget) {
      orderSummaryState.subscriptionUpsell = null;
      return;
    }

    const mainProductEl = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__main-product'
    );
    if (!mainProductEl || !mainProductEl.classList.contains('selected')) {
      orderSummaryState.subscriptionUpsell = null;
      return;
    }

    // Get product title
    const descriptionList = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__main-product-content ul'
    );
    let title = 'Fluoride Filters';
    if (descriptionList) {
      const firstListItem = descriptionList.querySelector('li:first-child');
      if (firstListItem) {
        const listText = firstListItem.textContent.trim();
        const match = listText.match(/Set of (\d+) (.+)/);
        if (match) {
          title = `${match[1]} ${match[2]}`;
        } else {
          title = listText.replace('Set of ', '');
        }
      }
    }

    // Get purchase option (one-time vs subscription)
    const subscriptionRadio = subscriptionWidget.querySelector(
      'input[type="radio"][value="subscription"]:checked'
    );
    const isSubscription = !!subscriptionRadio;

    // Get subscription info if subscription (always refresh from DOM)
    let subscriptionInfo = null;
    if (isSubscription) {
      // Clear cached subscription info first to force fresh fetch
      delete orderSummaryState.subscriptionInfo['subscription-upsell'];
      subscriptionInfo = getSubscriptionInfo('subscription-upsell', true);
      if (subscriptionInfo) {
        orderSummaryState.subscriptionInfo['subscription-upsell'] =
          subscriptionInfo;
      }
    } else {
      // Clear subscription info if switching to one-time
      delete orderSummaryState.subscriptionInfo['subscription-upsell'];
      subscriptionInfo = null;
    }

    // Get price from the widget price display
    let price = 0;
    let compareAtPrice = 0;

    // Try to get price from the main product price display
    const mainProductPriceEl = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__main-product-price strong'
    );
    if (mainProductPriceEl) {
      const priceText = mainProductPriceEl.textContent.trim();
      // Extract price from text like "+ $99" or "+ $199"
      const priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        const priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
        price = Math.round(priceValue * 100); // Convert to cents
      }
    }

    // Try to get compare at price from the widget
    const comparePriceEl = subscriptionWidget.querySelector(
      '.subscription-upsell-widget__compare-at-price'
    );
    if (comparePriceEl) {
      const compareText = comparePriceEl.textContent.trim();
      const compareMatch = compareText.match(/[\d,]+\.?\d*/);
      if (compareMatch) {
        const compareValue = parseFloat(compareMatch[0].replace(/,/g, ''));
        compareAtPrice = Math.round(compareValue * 100); // Convert to cents
      }
    }

    // Try to get quantity from window or extract from description
    // Note: quantity here is cart quantity (1 for "Set of 2", 2 for "Set of 4")
    // But the title shows the filter count (2 or 4)
    let quantity = window.selectedQuantity || 1;

    // Extract filter count from description to determine cart quantity
    if (descriptionList) {
      const firstListItem = descriptionList.querySelector('li:first-child');
      if (firstListItem) {
        const listText = firstListItem.textContent.trim();
        const filterCountMatch = listText.match(/Set of (\d+)/);
        if (filterCountMatch) {
          const filterCount = parseInt(filterCountMatch[1]);
          // "Set of 2" = quantity 1, "Set of 4" = quantity 2
          quantity = filterCount === 4 ? 2 : 1;
        }
      }
    }

    // If we couldn't get price from display, try to get from one-time option price
    if (price === 0) {
      const oneTimePriceEl = subscriptionWidget.querySelector(
        '.subscription-upsell-widget__option[data-option="one_time"] .subscription-upsell-widget__price strong'
      );
      if (oneTimePriceEl) {
        const priceText = oneTimePriceEl.textContent.trim();
        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
          const priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
          price = Math.round(priceValue * 100);
        }
      }
    }

    // If subscription, get discounted price from subscription option
    if (isSubscription && price > 0) {
      const subscriptionPriceEl = subscriptionWidget.querySelector(
        '.subscription-upsell-widget__option[data-option="subscription"] .subscription-upsell-widget__discounted-price strong'
      );
      if (subscriptionPriceEl) {
        const priceText = subscriptionPriceEl.textContent.trim();
        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
          const priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
          price = Math.round(priceValue * 100);
        }
      }
    }

    orderSummaryState.subscriptionUpsell = {
      id: 'subscription-upsell',
      title: title,
      price: price,
      compareAtPrice: compareAtPrice,
      quantity: quantity,
      isSubscription: isSubscription,
      subscriptionInfo: subscriptionInfo,
    };

    updateOrderSummary();
  }

  // Update upsells from DOM
  function updateUpsells() {
    orderSummaryState.upsells = [];

    // Get all active upsell containers (including priming pump)
    // Also check for checked checkboxes as a fallback (in case active class wasn't added)
    const activeContainers = document.querySelectorAll(
      '.upsell-container.active'
    );
    const checkedCheckboxes = document.querySelectorAll(
      '.upsell-checkbox:checked'
    );

    // Combine both: containers with active class and containers with checked checkboxes
    const allUpsellContainers = new Set();
    activeContainers.forEach(container => allUpsellContainers.add(container));
    checkedCheckboxes.forEach(checkbox => {
      // Find the container that contains this checkbox
      const container = checkbox.closest('.upsell-container');
      if (container) {
        allUpsellContainers.add(container);
      }
    });

    allUpsellContainers.forEach(container => {
      // Get upsell ID from container ID
      const containerId = container.id;
      if (!containerId) return;

      // Check if this is a priming pump upsell
      const isPrimingPump = container.classList.contains('priming-pump-upsell');

      let upsellId;
      let costEl;
      let comparePriceEl;
      let titleEl;

      if (isPrimingPump) {
        // Handle priming pump upsell
        // ID format: "priming-pump-{productId}-upsell-container"
        const match = containerId.match(/priming-pump-(\d+)-upsell-container/);
        if (match) {
          const productId = match[1];
          upsellId = 'priming-pump-' + productId;
          costEl = document.getElementById(upsellId + '-upsell-cost');
          // Priming pump doesn't have compare price input, but we can get it from the product
          comparePriceEl = null;
          titleEl = container.querySelector('.upsell-info-title strong');
        } else {
          return;
        }
      } else {
        // Handle regular and variant-specific upsells
        if (containerId.includes('-upsell-container')) {
          // Check if this is a variant-specific upsell container
          // Variant-specific format: "variantId-upsellId-upsell-container"
          // Regular format: "upsellId-upsell-container"
          const isVariantSpecific = container.classList.contains(
            'variant-upsell-container'
          );

          // First, try to find the cost input within the container
          // This works for both regular and variant-specific upsells
          costEl = container.querySelector('input[id$="-upsell-cost"]');

          if (costEl && costEl.id) {
            // Extract upsellId from the cost input ID (format: "upsellId-upsell-cost")
            upsellId = costEl.id.replace('-upsell-cost', '');
          } else {
            // Fallback: extract from container ID
            upsellId = containerId.replace('-upsell-container', '');

            if (isVariantSpecific) {
              // For variant-specific, container ID is "variantId-upsellId"
              // Try to find the cost element by checking different parts
              const parts = upsellId.split('-');

              // Try from the end: last part, last 2 parts, etc.
              for (let i = parts.length - 1; i >= 1; i--) {
                const testUpsellId = parts.slice(i).join('-');
                const testCostEl = document.getElementById(
                  testUpsellId + '-upsell-cost'
                );
                if (testCostEl) {
                  upsellId = testUpsellId;
                  costEl = testCostEl;
                  break;
                }
              }

              // If still not found, try the last part only (most common case)
              if (!costEl && parts.length >= 2) {
                upsellId = parts[parts.length - 1];
                costEl = document.getElementById(upsellId + '-upsell-cost');
              }
            } else {
              // Regular upsell - try to find cost element globally
              costEl = document.getElementById(upsellId + '-upsell-cost');
            }
          }
        } else {
          return;
        }

        // Get compare price element
        if (!comparePriceEl) {
          comparePriceEl =
            container.querySelector('input[id$="-upsell-compare-price"]') ||
            document.getElementById(upsellId + '-upsell-compare-price');
        }

        // Get title element
        titleEl = container.querySelector('.upsell-info-title strong');
      }

      if (!costEl && !isPrimingPump) return;

      // Get price - priming pump is always 0 (free)
      let price = 0;
      if (isPrimingPump) {
        price = 0; // Priming pump is always free
      } else if (costEl) {
        price = parseInt(costEl.value) || 0;
      }

      // For priming pump, try to get compare price from the strikethrough price in the DOM
      let comparePrice = 0;
      if (isPrimingPump) {
        const priceContainer = container.querySelector(
          '.upsell-price-original .strikethrough'
        );
        if (priceContainer) {
          // Extract price from text (e.g., "$40" -> 4000 cents)
          const priceText = priceContainer.textContent.trim();
          const priceMatch = priceText.match(/[\d,]+\.?\d*/);
          if (priceMatch) {
            const priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
            comparePrice = Math.round(priceValue * 100); // Convert to cents
          }
        }
      } else {
        comparePrice = comparePriceEl ? parseInt(comparePriceEl.value) || 0 : 0;
      }

      const title = titleEl ? titleEl.textContent.trim() : '';

      if (title && price >= 0) {
        // Check if this upsell is already in the list (prevent duplicates)
        const existingUpsell = orderSummaryState.upsells.find(
          u => u.id === upsellId
        );
        if (existingUpsell) {
          // Skip if already added
          return;
        }

        // Regular upsells (priming pump, water spigot, etc.) don't have subscriptions
        // Only the subscription upsell widget item has subscription info
        // So we don't store subscription info for regular upsells

        orderSummaryState.upsells.push({
          id: upsellId,
          title: title,
          price: price,
          compareAtPrice: comparePrice,
          quantity: 1,
        });
      }
    });

    updateOrderSummary();
  }

  // Main update function
  function updateOrderSummary() {
    updateItemCount();
    renderOrderSummaryItems();
  }

  // Toggle order summary details
  function toggleOrderSummary() {
    if (!toggleBtn || !detailsEl) return;

    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

    const translations = window.orderSummaryData?.translations || {
      viewDetails: 'View Details',
      hideDetails: 'Hide Details',
    };

    if (isExpanded) {
      // Collapse
      toggleBtn.setAttribute('aria-expanded', 'false');
      detailsEl.style.display = 'none';
      if (toggleTextEl) {
        toggleTextEl.textContent = translations.viewDetails;
      }
      if (toggleIconPlus) toggleIconPlus.style.display = 'block';
      if (toggleIconMinus) toggleIconMinus.style.display = 'none';
    } else {
      // Expand
      toggleBtn.setAttribute('aria-expanded', 'true');
      detailsEl.style.display = 'block';
      if (toggleTextEl) {
        toggleTextEl.textContent = translations.hideDetails;
      }
      if (toggleIconPlus) toggleIconPlus.style.display = 'none';
      if (toggleIconMinus) toggleIconMinus.style.display = 'block';
    }
  }

  // Initialize
  function init() {
    // Toggle button event
    if (toggleBtn) {
      toggleBtn.addEventListener('click', toggleOrderSummary);
    }

    // Listen for variant changes
    document.addEventListener('product:variant-change', function (evt) {
      const variant = evt.detail.variant;
      updateMainProduct(variant);
    });

    // Also listen for bx:variant-selected event (from bx-system-subscription)
    document.addEventListener('bx:variant-selected', function (evt) {
      const variant = evt.detail.variant;
      if (variant) {
        updateMainProduct(variant);
      }
    });

    // Listen for upsell toggles by observing DOM changes
    // Since toggleUpsell is called, we can listen to the active class changes
    const upsellObserver = new MutationObserver(function (mutations) {
      let shouldUpdate = false;
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const target = mutation.target;
          if (target.classList.contains('upsell-container')) {
            shouldUpdate = true;
          }
        }
      });
      if (shouldUpdate) {
        // Debounce updates
        clearTimeout(window.orderSummaryUpdateTimeout);
        window.orderSummaryUpdateTimeout = setTimeout(updateUpsells, 100);
      }
    });

    // Function to observe all upsell containers
    function observeUpsellContainers() {
      const upsellContainers = document.querySelectorAll('.upsell-container');
      upsellContainers.forEach(container => {
        // Only observe if not already observed (check if it has a data attribute)
        if (!container.dataset.orderSummaryObserved) {
          upsellObserver.observe(container, {
            attributes: true,
            attributeFilter: ['class'],
          });
          container.dataset.orderSummaryObserved = 'true';
        }
      });
    }

    // Initial observation
    observeUpsellContainers();

    // Also listen for checkbox changes directly (fallback for when active class isn't added)
    document.addEventListener('change', function (evt) {
      if (evt.target.classList.contains('upsell-checkbox')) {
        // Debounce updates
        clearTimeout(window.orderSummaryUpdateTimeout);
        window.orderSummaryUpdateTimeout = setTimeout(updateUpsells, 100);
      }
    });

    // Re-observe when variant changes (new variant-specific sections might be shown)
    document.addEventListener('product:variant-change', function () {
      setTimeout(observeUpsellContainers, 100);
      setTimeout(updateUpsells, 200);
    });

    // Also listen to custom events if available
    document.addEventListener('subscriptionUpsell:enabled', function (evt) {
      updateUpsells();
      if (evt.detail) {
        updateSubscriptionUpsell(evt.detail);
      }
    });

    // Listen for subscription widget changes
    const subscriptionWidgets = document.querySelectorAll(
      '.subscription-upsell-widget'
    );
    subscriptionWidgets.forEach(widget => {
      const subscriptionRadio = widget.querySelector(
        'input[type="radio"][value="subscription"]'
      );
      const oneTimeRadio = widget.querySelector(
        'input[type="radio"][value="one_time"]'
      );
      const sellingPlanSelect = widget.querySelector(
        'select[id*="selling_plan"]'
      );

      if (subscriptionRadio) {
        subscriptionRadio.addEventListener('change', function () {
          updateSubscriptionUpsellFromDOM();
        });
      }

      if (oneTimeRadio) {
        oneTimeRadio.addEventListener('change', function () {
          updateSubscriptionUpsellFromDOM();
        });
      }

      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', function () {
          updateSubscriptionUpsellFromDOM();
        });
      }
    });

    // Initial update - try to get current variant
    function initializeMainProduct() {
      const selectedVariantCostEl = document.getElementById(
        'selectedVariantCost'
      );

      // Try multiple methods to get the initial variant
      let variant = null;

      // Method 1: Check if selectedVariantCost exists (from product-option.liquid)
      if (selectedVariantCostEl && selectedVariantCostEl.value) {
        // Try to get variant from window.variants or window.product.variants
        if (window.variants && Array.isArray(window.variants)) {
          const variantId = parseInt(selectedVariantCostEl.value);
          variant = window.variants.find(v => v.id === variantId);
        } else if (window.product && window.product.variants) {
          const variantId = parseInt(selectedVariantCostEl.value);
          variant = window.product.variants.find(v => v.id === variantId);
        } else if (window.selectedVariantId) {
          // Use window.selectedVariantId if available
          const variantId = window.selectedVariantId;
          if (window.variants) {
            variant = window.variants.find(v => v.id === variantId);
          } else if (window.product && window.product.variants) {
            variant = window.product.variants.find(v => v.id === variantId);
          }
        }
      }

      // Method 2: Try to get from product form
      if (!variant) {
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            const variantId = parseInt(variantInput.value);
            if (window.variants) {
              variant = window.variants.find(v => v.id === variantId);
            } else if (window.product && window.product.variants) {
              variant = window.product.variants.find(v => v.id === variantId);
            }
          }
        }
      }

      // Method 3: Use selectedVariantId from window
      if (!variant && window.selectedVariantId) {
        const variantId = window.selectedVariantId;
        if (window.variants) {
          variant = window.variants.find(v => v.id === variantId);
        } else if (window.product && window.product.variants) {
          variant = window.product.variants.find(v => v.id === variantId);
        } else if (window.system_variants) {
          variant = window.system_variants.find(v => v.id === variantId);
        }
      }

      // Method 4: Try to get from active filter option (for filtration system products)
      if (!variant) {
        const activeFilterOption = document.querySelector(
          '.filter-option-container.active'
        );
        if (activeFilterOption) {
          const variantIdAttr =
            activeFilterOption.getAttribute('data-variant-id');
          if (variantIdAttr) {
            const variantId = parseInt(variantIdAttr);
            if (window.variants) {
              variant = window.variants.find(v => v.id === variantId);
            } else if (window.product && window.product.variants) {
              variant = window.product.variants.find(v => v.id === variantId);
            } else if (window.system_variants) {
              variant = window.system_variants.find(v => v.id === variantId);
            }
          }
        }
      }

      // If we found a variant, update the main product
      if (variant) {
        updateMainProduct(variant);
      } else if (selectedVariantCostEl && selectedVariantCostEl.value) {
        // If we have price info but no variant object, create a minimal variant object
        const price = parseInt(selectedVariantCostEl.value) || 0;
        const comparePriceEl = document.getElementById(
          'selectedVariantComparePrice'
        );
        const comparePrice = comparePriceEl
          ? parseInt(comparePriceEl.value) || 0
          : 0;

        // Try to get product title
        const productTitleEl = document.querySelector(
          '.product-title, h1.product-title, [data-product-title]'
        );
        let title = productTitleEl
          ? productTitleEl.textContent.trim()
          : 'System';

        // Try to get variant info from active filter option
        const activeFilterOption = document.querySelector(
          '.filter-option-container.active'
        );
        if (activeFilterOption) {
          const filterCount = activeFilterOption.getAttribute(
            'data-variant-filter-count'
          );
          if (filterCount) {
            title = `${title} (${filterCount})`;
          }
        }

        orderSummaryState.mainProduct = {
          id: window.selectedVariantId || 0,
          title: title,
          price: price,
          compareAtPrice: comparePrice,
          variant: null,
        };
        updateOrderSummary();
      }
    }

    // Listen for priming pump selection events
    document.addEventListener('priming-pump:selected', function (evt) {
      updateUpsells();
    });

    // Listen for subscription upsell widget events (handled above in the other listener)

    // Initialize main product
    initializeMainProduct();

    // Wait a bit for variant data to be available in window
    setTimeout(function () {
      initializeMainProduct();
    }, 100);

    // Initial upsell check (with delay to ensure DOM is ready)
    setTimeout(function () {
      updateUpsells();
      updateSubscriptionUpsellFromDOM();
    }, 200);

    // Also check again after a longer delay to catch any late-loading elements
    setTimeout(function () {
      updateUpsells();
      updateSubscriptionUpsellFromDOM();
    }, 500);

    // One more check after everything should be loaded
    setTimeout(function () {
      initializeMainProduct();
      updateUpsells();
      updateSubscriptionUpsellFromDOM();
    }, 1000);

    // Observe subscription widget for selection changes
    const subscriptionWidget = document.querySelector(
      '.subscription-upsell-widget'
    );
    if (subscriptionWidget) {
      const mainProductEl = subscriptionWidget.querySelector(
        '.subscription-upsell-widget__main-product'
      );
      if (mainProductEl) {
        const subscriptionObserver = new MutationObserver(function (mutations) {
          let shouldUpdate = false;
          mutations.forEach(function (mutation) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'class'
            ) {
              shouldUpdate = true;
            }
          });
          if (shouldUpdate) {
            clearTimeout(window.subscriptionUpsellUpdateTimeout);
            window.subscriptionUpsellUpdateTimeout = setTimeout(function () {
              updateSubscriptionUpsellFromDOM();
            }, 100);
          }
        });

        subscriptionObserver.observe(mainProductEl, {
          attributes: true,
          attributeFilter: ['class'],
        });

        // Also observe radio button changes
        const subscriptionRadio = subscriptionWidget.querySelector(
          'input[type="radio"][value="subscription"]'
        );
        const oneTimeRadio = subscriptionWidget.querySelector(
          'input[type="radio"][value="one_time"]'
        );
        if (subscriptionRadio) {
          subscriptionRadio.addEventListener('change', function () {
            updateSubscriptionUpsellFromDOM();
          });
        }
        if (oneTimeRadio) {
          oneTimeRadio.addEventListener('change', function () {
            updateSubscriptionUpsellFromDOM();
          });
        }

        // Observe frequency button changes
        const frequencyButtons = subscriptionWidget.querySelectorAll(
          '.subscription-upsell-widget__frequency-button'
        );
        frequencyButtons.forEach(button => {
          button.addEventListener('click', function () {
            // Clear cached subscription info to force refresh
            if (orderSummaryState.subscriptionInfo['subscription-upsell']) {
              delete orderSummaryState.subscriptionInfo['subscription-upsell'];
            }
            // Update after a short delay to ensure DOM is updated
            setTimeout(updateSubscriptionUpsellFromDOM, 100);
          });
        });

        // Also observe frequency button active class changes via MutationObserver
        frequencyButtons.forEach(button => {
          const frequencyObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class' &&
                button.classList.contains('active')
              ) {
                // Clear cached subscription info to force refresh
                if (orderSummaryState.subscriptionInfo['subscription-upsell']) {
                  delete orderSummaryState.subscriptionInfo[
                    'subscription-upsell'
                  ];
                }
                // Update after a short delay
                clearTimeout(window.subscriptionUpsellFrequencyUpdateTimeout);
                window.subscriptionUpsellFrequencyUpdateTimeout = setTimeout(
                  updateSubscriptionUpsellFromDOM,
                  100
                );
              }
            });
          });
          frequencyObserver.observe(button, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
